window._nav = function () {
  var timeline = new gsap.timeline()

  return {
    menu: -1,
    children: false,

    open(index, children) {
      if (this.menu === index) {
        return
      }

      timeline.clear()

      var dropper = this.$refs.dropper
      var container = this.$refs.container
      var current = this.$refs[`menu-${index}`]
      var previous = this.$refs[`menu-${this.menu}`]

      // hide if no children
      if (!children) {
        this.menu = index
        this.children = children

        timeline
          .to(dropper, { duration: 0, y: "-100%", opacity: 0 })
          .to(container, { duration: 0, x: 0, opacity: 0 })
          .play()
        return
      }

      if (this.menu !== -1) {
        timeline
          .to(previous, {
            duration: 0.2,
            x: index > this.menu ? 100 : -100,
            opacity: 0
          })
          .to(previous, {
            duration: 0,
            x: 0
          })
      }

      timeline
        .to(container, {
          x: `${-(index - 1) * 100}vw`,
          duration: 0,
          opacity: 0
        })
        .to(current, {
          duration: 0,
          opacity: 0
        })
        .to(container, {
          duration: 0,
          opacity: 1
        })

      // reset if not open at all, or if new selection has children
      if (this.menu === -1) {
        timeline
          .to(dropper, { duration: 0, y: "-100%", opacity: 0 })
          .to(dropper, {
            duration: 0.2,
            y: 0,
            opacity: 1
          })
      }

      timeline.to(dropper, {
        duration: 0.3,
        y: 0,
        opacity: 1
      })
      timeline
        .to(current, {
          x: index > this.menu ? -100 : 100,
          opacity: 0,
          duration: 0
        })
        .to(current, {
          x: 0,
          duration: 0.1,
          opacity: 1
        })

      this.menu = index
      this.children = children
      timeline.play()
    },

    hide() {
      timeline.clear()

      var dropper = this.$refs.dropper
      var container = this.$refs.container

      timeline
        .to(dropper, { duration: 0, y: "-100%", opacity: 0 })
        .to(container, { duration: 0, x: 0, opacity: 0 })
        .play()

      this.menu = -1
      this.children = false
    },

    userMenuReady() {
      var dropper = this.$refs.dropper

      var tl = gsap.timeline()
      tl.to(dropper, { duration: 0, y: "-100%", opacity: 0 })

      this.menu = -2
      this.children = false
    }
  }
}

window._resourceFilter = function (token) {
  let params = new URLSearchParams(window.location.search)

  let isMobile = () => window.innerWidth < 768

  return {
    showFilters: false,
    loading: false,
    token: token,
    types: params.getAll("types"),
    categories: params.getAll("categories"),
    locations: params.getAll("locations"),
    years: params.getAll("years"),
    section: "",
    icons: {
      Europe:
        '<svg width="16" height="16" fill="none"><g fill="currentColor" clip-path="url(#a)"><path d="M2.459 1.993a.48.48 0 0 1 .396.405c.018.127.057.218.11.254.139.097.887-.032 1.192-.42a.412.412 0 0 0 .086-.34.594.594 0 0 0-.285-.385c-.11-.063-.26-.049-.366-.026a.473.473 0 0 1-.546-.303C2.98.993 2.878.964 2.799.964h-.02c-.133.008-.27.129-.377.333-.135.256-.16.53-.119.6.03.048.09.08.176.096ZM10.585 13.439c-.224-.06-.418-.11-.551-.188-.467-.268-.845-.873-.627-1.464.114-.308.479-.506.831-.699.39-.213.643-.365.588-.531-.072-.216-.215-.216-.607-.104-.136.038-.265.075-.384.075-.255 0-.513-.135-.628-.328a.4.4 0 0 1-.012-.409c.09-.164.258-.232.407-.292.141-.058.263-.107.321-.222.13-.258.05-.884-.215-1.197-.12-.143-.345-.198-.512-.219a.589.589 0 0 1-.52-.593c.005-.286-.043-.494-.13-.573-.024-.02-.064-.046-.147-.035-.22.03-.19.394-.126.866.05.366.088.655-.058.805-.183.188-.438.2-.685.21a1.647 1.647 0 0 0-.472.068c-.16.057-.298.272-.444.5-.164.256-.333.522-.586.643-.196.094-.485.103-.792.113-.401.013-.856.028-.937.253-.07.195.031.29.296.474.158.109.32.222.397.395.168.379.304 1.423-.107 1.655-.286.163-.51-.003-.674-.125-.067-.05-.13-.097-.184-.113-.077-.023-.162 0-.26.027-.124.034-.264.073-.417.023-.153-.049-.227-.182-.293-.3-.074-.13-.125-.211-.23-.227a.635.635 0 0 0-.095-.007c-.278 0-.638.157-.74.397-.058.136.005.282.08.451.067.156.144.332.127.527-.018.205-.134.367-.246.523-.124.174-.23.324-.205.514.028.203.159.274.37.374.112.053.228.108.317.199.113.116.148.32.184.537.035.207.078.464.186.464.105 0 .163-.133.24-.336.073-.195.15-.396.336-.457.217-.07.37.05.494.147.093.073.18.142.297.149.285.015.835-.346.89-.54.02-.07.002-.171-.017-.28-.038-.22-.086-.495.13-.738.183-.205.449-.227.662-.245.14-.012.272-.023.31-.08.045-.07.052-.18.059-.297.012-.195.026-.437.26-.553.21-.105.394-.005.542.075.113.06.22.118.334.1.078-.013.148-.108.23-.219.152-.206.36-.49.81-.41.46.081.532.402.59.66.036.158.07.308.176.428.131.15.416.246.692.339.353.12.687.232.78.484.059.157.05.343.042.523-.016.368.006.489.174.524.147.03.293-.09.367-.165.262-.265.422-.727.357-1.03-.067-.306-.57-.44-.975-.546Z"/><path d="M8.178 13.464c-.158 0-.291.22-.291.479s.133.478.291.478c.158 0 .291-.22.291-.478 0-.26-.133-.479-.291-.479ZM9.846 15.487a.735.735 0 0 0-.354-.123h-.015c-.077 0-.135.02-.16.058-.058.092.048.306.278.454.23.149.468.156.528.065.026-.041.019-.108-.019-.184a.734.734 0 0 0-.258-.27ZM6.175 14.392a.208.208 0 1 0 0 .416.208.208 0 0 0 0-.416ZM13.005 3.227c-.039-.228-.26-.447-.496-.679-.257-.254-.55-.542-.658-.91-.084-.285-.07-.6-.057-.878.02-.414.02-.671-.179-.739-.42-.14-1.35.437-1.81 1.124-.236.353-.286.8-.335 1.233-.045.398-.087.774-.274 1.056-.223.338-.521.437-.81.532-.228.076-.442.147-.635.331-.257.246-.32.757-.248 1.134.05.264.16.455.295.511.16.066.286-.045.48-.23.158-.153.335-.323.563-.323.037 0 .076.004.116.014.389.095.392.453.395.74.001.184.003.374.088.503.091.137.22.215.36.22a.353.353 0 0 0 .288-.122c.053-.07.038-.173.006-.335-.027-.137-.057-.292-.018-.446.037-.138.12-.24.2-.338.113-.136.219-.265.22-.51 0-.153-.072-.274-.156-.414-.099-.166-.21-.355-.216-.626-.008-.415.364-1.372.803-1.682.19-.134.349-.118.449-.08.384.144.225.597.071 1.035-.127.363-.272.775-.16 1.052.076.189.205.31.383.362.271.078.615-.022.8-.156.275-.2.621-.867.535-1.38ZM11.046 6.479c.058.02.116-.012.146-.033a.398.398 0 0 0 .14-.2.397.397 0 0 0 .005-.245c-.011-.034-.039-.094-.098-.113a.12.12 0 0 0-.038-.006.197.197 0 0 0-.108.039.398.398 0 0 0-.14.2.399.399 0 0 0-.006.245c.012.034.04.094.099.113ZM14.207 14.553c-.05-.09-.189-.172-.311-.243-.179-.104-.363-.212-.376-.4-.015-.234.157-.41.308-.564.184-.187.258-.28.198-.393-.014-.026-.036-.053-.097-.062a.295.295 0 0 0-.04-.003c-.269 0-.774.308-1.042.586-.153.158-.483.56-.265.891.105.158.282.174.541.181.104.003.203.006.292.028.171.042.29.154.386.245.118.112.175.156.258.141a.227.227 0 0 0 .174-.124c.038-.08.028-.185-.026-.283ZM13.065 15.347a.41.41 0 0 0-.145-.028c-.097 0-.171.039-.192.093-.03.08.047.213.208.274.079.03.162.036.23.017.032-.009.088-.031.107-.083.03-.08-.047-.212-.208-.273ZM4.763 9c.463.033 1.055-.123 1.2-.41.129-.255-.108-.71-.317-1.112-.185-.355-.344-.662-.297-.891.053-.256.22-.382.353-.484.143-.109.192-.157.177-.272-.026-.193-.197-.429-.398-.548a.519.519 0 0 0-.256-.079.339.339 0 0 0-.124.023c-.301.117-.358.872-.283 1.348.024.148.073.32.121.486.1.343.193.667.118.914-.055.18-.241.297-.42.412-.272.172-.395.27-.343.422.032.097.216.172.47.19ZM2.98 7.785c-.136.174-.209.28-.145.422.02.044.05.07.101.083.18.047.519-.083.723-.234a.992.992 0 0 0 .415-.609c.057-.22-.049-.548-.211-.649-.147-.091-.518-.1-.639.052-.057.071-.052.127-.036.245a.77.77 0 0 1-.02.381c-.04.116-.115.214-.189.309Z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>',
      Asia: '<svg width="16" height="16" fill="none"><g fill="currentColor"><path d="M13.403 5.398c.08.383.084.518-.06.563-.132.041-.325-.186-.495-.387-.256-.301-.575-.676-.943-.425-.316.216-.174.683-.01 1.225.166.55.354 1.172.11 1.61-.301.543-.809.587-1.256.625-.248.021-.483.041-.65.15-.423.277-.44 1.06-.307 1.377.043.104.111.196.177.285.164.222.181.283.106.364-.068.073-.177.056-.349.021-.181-.036-.407-.082-.569.093-.329.356-.157 1.795-.059 2.132.112.383.393.9.815 1.096.134.061.307.094.475.125.402.075.568.13.552.281-.004.03-.016.07-.08.107-.251.143-.904.047-1.297-.132-.443-.2-1.034-1.073-1.17-1.728-.07-.33.04-.782.136-1.181.098-.41.184-.763.108-1.012-.102-.336-.322-.44-.498-.525-.097-.047-.182-.088-.243-.16-.075-.09-.071-.247-.067-.414.004-.19.009-.404-.107-.576-.106-.157-.306-.265-.549-.297a1.087 1.087 0 0 0-.14-.009.8.8 0 0 0-.525.173c-.188.165-.212.37-.23.536-.014.115-.025.214-.084.288-.052.065-.146.11-.245.156-.19.09-.425.202-.48.518-.037.22.097.497.238.791.122.252.288.597.195.7-.019.022-.05.046-.12.036-.252-.034-.667-.427-.805-.708-.1-.205-.09-.439-.08-.645.008-.148.014-.288-.023-.404-.045-.143-.166-.256-.294-.375-.104-.097-.212-.197-.265-.306-.07-.145-.074-.274-.077-.424-.002-.126-.005-.256-.048-.402-.1-.334-.522-.758-.939-.825-.226-.037-.409.06-.555.138-.123.065-.2.104-.258.077-.04-.02-.067-.09-.07-.186-.007-.24.124-.536.277-.62.117-.064.265-.04.422-.014.195.032.416.068.586-.089.19-.174.183-.39.177-.562-.003-.11-.006-.203.035-.272.05-.087.153-.127.272-.173.17-.067.381-.15.42-.414.024-.163-.045-.317-.193-.433a.923.923 0 0 0-.867-.115c-.184.075-.321.224-.453.368-.191.208-.32.333-.501.31-.163-.022-.237-.161-.34-.39-.076-.17-.155-.347-.321-.422-.113-.051-.247-.047-.378-.043-.223.007-.307-.005-.338-.087-.034-.092.063-.384.133-.596.145-.435.309-.928-.037-1.077-.26-.113-.47.09-.638.252-.161.156-.276.255-.388.217-.087-.03-.17-.176-.21-.373-.07-.354-.005-.853.255-1.082.213-.187.435-.113.774.032.2.085.406.173.6.134.246-.05.41-.336.584-.64.158-.277.338-.59.545-.63.258-.05.417.09.617.266.122.108.248.22.407.288.216.093.462.079.7.065.23-.014.469-.028.677.056.19.077.262.295.333.507.073.22.148.448.37.505.268.07.426-.103.552-.242.08-.09.157-.173.257-.205.113-.036.212.014.364.1.13.074.277.158.461.161.214.004.365-.121.511-.243.136-.113.264-.22.45-.246.15-.021.412.052.69.13.466.131 1.046.294 1.595.182.573-.117.748-.414.889-.652.085-.145.152-.259.295-.319.095-.04.243-.022.417.05.411.172.841.58.937.817.063.157.038.349.014.534-.032.242-.065.492.115.658.147.136.38.146.605.156.305.013.435.036.453.143.02.126-.257.293-.479.427-.283.17-.576.347-.65.6-.056.19-.008.416.039.636Z"/><path d="M11.159 12.652c-.033.337-.16.635-.298.693-.18.076-.603.032-.728-.106a.719.719 0 0 1-.15-.478c.003-.034.014-.094.05-.12.048-.036.077-.032.145-.023.1.013.236.031.42-.099.157-.11.214-.298.265-.464.06-.198.09-.264.156-.264.017 0 .031.005.05.024.091.102.128.438.09.837ZM11.914 10.879a.087.087 0 0 1 .043-.01c.095 0 .263.106.39.324.148.259.132.488.056.532-.037.02-.101.008-.172-.034a.79.79 0 0 1-.26-.28.792.792 0 0 1-.114-.367c0-.082.02-.144.057-.165ZM12.165 9.508a.79.79 0 0 1 .299-.24.305.305 0 0 1 .111-.025.1.1 0 0 1 .063.018c.07.055.052.284-.134.517a.788.788 0 0 1-.3.24c-.075.031-.14.034-.174.008-.069-.055-.05-.284.135-.518ZM10.649 9.558c.044-.077.12-.124.19-.124.025 0 .048.006.07.018.035.02.06.059.07.107a.25.25 0 0 1-.033.17.25.25 0 0 1-.131.114.152.152 0 0 1-.128-.008.153.153 0 0 1-.071-.107.25.25 0 0 1 .033-.17ZM12.748 13.161c-.137.06-.323.143-.399.374-.076.235.034.414.114.545.076.125.102.179.069.245-.023.045-.105.069-.212.06-.22-.016-.49-.164-.56-.383-.122-.382.23-.94.512-1.06a.918.918 0 0 1 .348-.072.44.44 0 0 1 .236.055c.039.025.056.055.056.098 0 .056-.025.076-.165.138ZM15.263 14.97c-.115.063-.654-.086-.788-.277-.047-.068-.042-.13-.03-.236.015-.117.034-.263-.078-.41-.11-.144-.252-.194-.378-.237a.554.554 0 0 1-.216-.11c-.047-.047-.065-.13-.046-.211.019-.077.065-.135.124-.154a.675.675 0 0 1 .194-.023c.265 0 .676.09.92.366.312.353.39 1.169.298 1.293ZM15.984 4.348c-.05.185-.207.304-.348.265a.235.235 0 0 1-.148-.137.4.4 0 0 1-.016-.269c.044-.161.169-.273.294-.273.018 0 .036.003.054.008a.235.235 0 0 1 .149.137.4.4 0 0 1 .015.269ZM15.662 5.778c-.039.266-.487.783-.894.948-.382.155-.795.206-.94.116-.034-.022-.05-.048-.052-.092-.01-.14.265-.23.507-.31.205-.067.399-.13.524-.241.16-.14.195-.346.222-.511.034-.206.057-.286.16-.312a.38.38 0 0 1 .348.091c.092.084.14.203.124.311Z"/></g></svg>',
      "North America":
        '<svg width="16" height="16" fill="none"><g fill="currentColor" clip-path="url(#a)"><path d="M15.182 4.853c-.232-.065-.353.034-.506.158-.139.113-.296.241-.535.206-.238-.036-.359-.21-.456-.351-.12-.174-.18-.249-.353-.21-.148.033-.324.427-.465.744-.238.534-.506 1.138-.977 1.087-.32-.036-.402-.342-.466-.588-.04-.15-.08-.303-.162-.388-.066-.068-.176-.134-.292-.203-.28-.167-.664-.395-.49-.82.131-.322.639-.487 1.176-.662.412-.134.88-.286.973-.475a.147.147 0 0 0 .005-.121c-.11-.317-1.275-.043-2.046.138-.606.142-1.178.277-1.525.253-.526-.036-.81-.244-1.061-.427-.186-.136-.346-.253-.584-.285-.282-.039-.579.066-.892.178-.318.112-.647.23-.994.207-.262-.016-.563-.136-.91-.276-.573-.23-1.22-.49-1.859-.345C1.738 2.907.362 3.875.093 4.271c-.117.17-.124.43-.02.662.088.193.232.32.386.34.168.02.398-.09.665-.22.406-.195.912-.44 1.476-.324.316.065.568.242.748.524.348.545.33 1.335.2 1.893-.105.439-.298.768-.468 1.059-.201.343-.375.64-.398 1.06-.02.361.085 1.081.259 1.792.212.868.412 1.252.493 1.297.123.069.246.068.39.067.177-.002.379-.003.59.137.184.12.362.445.568.821.203.37.432.788.619.886.188.1.327.075.519.042.108-.019.225-.04.362-.04.07 0 .146.006.229.02.269.045.584.39.949.788.377.412.845.925 1.162.925.32 0 .568-.097.664-.26a.22.22 0 0 0 .007-.229c-.049-.088-.174-.106-.375-.125-.188-.018-.401-.038-.559-.178-.198-.176-.165-.4-.141-.563.02-.131.029-.214-.02-.277-.055-.073-.172-.086-.308-.1-.17-.018-.38-.041-.502-.222-.116-.172-.033-.377.04-.558.092-.227.11-.311.031-.367-.084-.06-.28.014-.47.086-.309.115-.691.26-.978-.015-.182-.176-.25-.467-.186-.799a1.788 1.788 0 0 1 1.077-1.276c.599-.24 1.114.03 1.527.246.262.138.487.256.665.22.273-.057.378-.457.479-.844.064-.247.125-.48.233-.651.174-.278.518-.389.851-.497.248-.08.505-.162.662-.308.183-.171.287-.373.388-.568.102-.198.208-.403.392-.561.216-.186.628-.22 1.026-.255.307-.026.69-.058.783-.171.073-.089.038-.252.001-.424-.054-.252-.128-.597.236-.74.276-.11.548.06.787.21.287.18.472.284.645.142.09-.074.126-.4.024-.88-.126-.593-.404-1.124-.619-1.183ZM13.602 2.424c-.078.065-.206.192-.183.308.03.153.195.164.576.129.101-.01.2-.018.292-.018.156 0 .293.025.39.12.16.154.142.391.126.601-.02.278-.015.406.126.463.185.073.55-.064.816-.306.194-.177.286-.364.246-.5-.032-.106-.114-.132-.308-.17-.158-.031-.338-.066-.466-.214-.13-.151-.111-.334-.096-.48.02-.198.02-.27-.131-.33-.286-.115-1.025.096-1.388.397ZM10.945 1.075c.392.02.73.038.884.212.15.17.16.379.17.547.01.214.025.271.13.298.316.08.553-.178.805-.45.171-.186.333-.361.531-.443.196-.082.382-.107.545-.129.239-.032.445-.06.658-.245.221-.194.36-.471.337-.673-.01-.083-.044-.139-.106-.172-.124-.065-.486.041-.806.135-.334.099-.68.2-.985.205a3.12 3.12 0 0 1-.834-.12c-.242-.06-.45-.112-.677-.084-.478.061-1.247.291-1.446.565-.048.065-.046.112-.04.14.031.172.495.196.834.214ZM7.495 2.06c.095.05.262-.009.423-.065.133-.046.269-.094.397-.094.044 0 .087.006.129.02.173.054.239.198.297.324.062.136.11.243.274.289.413.117.836.122.984.012.054-.04.087-.11.095-.197.012-.159-.065-.337-.212-.49-.308-.319-1.577-.762-2.026-.57-.273.116-.424.38-.433.581-.002.045.001.151.072.19Z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>',
      "South America":
        '<svg width="16" height="16" fill="none"><g clip-path="url(#a)"><path fill="currentColor" d="M12.524 5.315c.213-.258.414-.502.414-.732 0-.445-.334-.842-.633-.898-.155-.03-.319.019-.477.066-.18.054-.367.11-.531.032-.166-.078-.23-.236-.286-.375-.045-.113-.085-.211-.166-.254-.068-.036-.143-.036-.238-.036-.173 0-.387 0-.621-.224-.186-.177-.253-.434-.312-.661-.052-.2-.101-.389-.217-.479-.124-.096-.3-.124-.489-.153-.207-.033-.441-.07-.65-.207-.18-.118-.302-.333-.42-.54C7.752.6 7.615.36 7.408.342c-.137-.011-.259.06-.388.136-.158.094-.339.2-.562.147C6.282.583 6.16.445 6.04.312 5.893.145 5.763 0 5.546 0a.53.53 0 0 0-.06.003c-.52.06-1.259.555-1.339.899-.041.178.012.374.063.563.06.223.122.454.03.664-.101.233-.327.33-.527.415-.142.06-.276.118-.36.214-.202.231-.391 1.26-.232 1.503.072.11.195.132.389.158.158.022.337.047.48.162.143.116.216.397.324.847.095.4.214.898.396 1.038.133.1.321.136.52.174.334.063.711.135.907.543.179.372.136 1.452.09 2.596-.03.73-.057 1.418-.017 1.806.106 1.016.963 3.345 1.389 3.776.473.478 1.064.627 1.338.639.126.005.227-.038.277-.118.046-.075.041-.175-.014-.273-.05-.089-.169-.108-.36-.13-.197-.021-.421-.046-.536-.242-.129-.22 0-.468.105-.666.061-.117.13-.25.116-.322-.016-.077-.08-.117-.194-.18-.113-.063-.254-.142-.323-.306-.117-.275-.147-1.207.19-1.545.202-.201.46-.175.667-.153.128.013.25.026.306-.022.063-.053.062-.21.06-.36 0-.21-.003-.449.14-.633.106-.139.27-.247.445-.362.227-.15.461-.304.558-.521.072-.163.056-.369.04-.587-.023-.289-.049-.616.137-.904.164-.254.447-.346.72-.436.288-.094.56-.183.722-.445.172-.275.12-.595.065-.934-.046-.286-.094-.583.007-.852.095-.251.28-.476.46-.694Z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>',
      Africa:
        '<svg width="16" height="16" fill="none"><g fill="currentColor" clip-path="url(#a)"><path d="M13.995 7.777c.193-.144.36-.268.485-.376.319-.275.735-1.066.725-1.498-.002-.06-.013-.14-.059-.175-.103-.081-.277 0-.552.145-.288.15-.614.322-.952.235-.448-.116-.524-.499-.584-.807-.033-.167-.064-.325-.142-.438-.102-.147-.27-.249-.449-.357-.225-.136-.482-.291-.644-.57-.13-.224-.138-.616-.146-1.032-.01-.501-.021-1.07-.258-1.256-.29-.228-.581-.22-.888-.211a2.04 2.04 0 0 1-.487-.025c-.2-.043-.379-.158-.551-.27-.213-.138-.396-.257-.547-.198-.096.038-.12.115-.152.297-.033.187-.08.444-.363.58-.306.147-.908.023-1.332-.127-.22-.079-.745-.292-.884-.588-.121-.259-.066-.492-.021-.68C6.236.25 6.247.17 6.19.108c-.154-.17-.714-.122-1.12.029-.161.06-.303.15-.44.238-.19.121-.386.247-.622.276-.193.024-.388-.047-.576-.115-.311-.113-.513-.17-.695-.01-.17.15-.17.46-.17.787 0 .341 0 .694-.202.926-.157.18-.418.324-.695.475-.365.2-.743.407-.785.662-.035.208.09.337.236.487.156.16.332.343.284.631-.041.244-.203.412-.345.56-.184.191-.295.319-.26.53.074.444 1.116 1.247 1.674 1.376.259.06.643-.036 1.015-.13.426-.105.828-.206 1.092-.087.243.11.358.307.46.48.103.176.185.315.376.356.156.033.304.027.448.02a4.11 4.11 0 0 1 .177-.004c.217 0 .442.033.683.224.483.382.728 2.138.7 2.635-.017.306-.204.568-.37.8-.142.2-.277.388-.277.562 0 .189.132.297.286.422.13.107.265.218.326.388.061.172.042.424.022.69-.02.272-.044.58.036.727.07.133.195.22.328.31.158.11.336.233.437.45.08.171.078.376.077.574-.003.298.006.486.154.574.299.178 1.423-.16 1.796-.54.18-.184.28-.44.374-.687.099-.255.192-.497.37-.663.16-.147.35-.208.517-.262.227-.073.358-.122.418-.285.049-.132-.037-.28-.137-.451-.124-.214-.28-.48-.117-.76.123-.21.296-.286.45-.353.184-.081.344-.151.449-.458.09-.26.006-.553-.081-.862-.104-.367-.222-.783-.068-1.224.214-.614.97-1.177 1.579-1.629ZM14.865 10.607a.182.182 0 0 0-.036-.004c-.12 0-.206.132-.328.34-.085.144-.165.28-.283.354-.114.073-.237.1-.356.125-.18.04-.293.07-.375.193-.075.112-.132.693.031 1.126.05.132.141.298.293.338a.373.373 0 0 0 .097.013c.427 0 .764-.741.862-.983.131-.321.279-1.2.14-1.457-.021-.04-.039-.044-.045-.045Z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>',
      Australia:
        '<svg width="16" height="16" fill="none"><g fill="currentColor" clip-path="url(#a)"><path d="M15.736 6.6c-.123-.18-.36-.318-.588-.45-.302-.176-.613-.358-.713-.663-.07-.216-.067-.447-.064-.67.004-.287.007-.536-.141-.688-.11-.114-.289-.135-.477-.159-.264-.032-.565-.07-.702-.386-.11-.254-.014-.548.07-.808.079-.243.153-.473.044-.59-.122-.132-.257-.192-.4-.255-.18-.08-.384-.171-.546-.414-.107-.16-.158-.424-.212-.704-.06-.31-.134-.695-.283-.791-.023-.015-.062-.032-.133-.015-.201.05-.187.839-.178 1.36.014.744.027 1.446-.294 1.66-.288.193-.877.006-1.202-.123-.402-.16-1.185-.56-1.27-.933-.058-.248.068-.466.19-.677.126-.22.246-.428.154-.657C8.913.44 8.558.239 8.09.125 7.585.002 7.083.015 6.92.155c-.157.135-.162.484-.167.791-.005.378-.01.77-.299.89-.271.113-.482-.074-.668-.239-.22-.194-.369-.307-.579-.236-.233.079-.57.584-.894 1.073-.39.586-.792 1.191-1.227 1.466-.394.248-.951.399-1.49.544-.547.148-1.113.3-1.287.523-.337.434-.367 1.812-.236 2.253.063.214.219.397.384.59.152.178.309.362.422.594.25.511.284 1.724.11 2.071-.09.184-.271.27-.416.338-.158.074-.228.115-.235.192-.002.029.023.084.1.15.214.184.665.327 1.021.24.278-.067.468-.264.652-.455.155-.16.301-.312.49-.372.194-.06.45.026.72.117.277.093.593.2.749.098.166-.108.21-.25.26-.416.045-.15.096-.318.245-.459.32-.3 1.859-.739 2.387-.68.589.067 1.247.514 1.468.873.102.165.108.393.114.613.01.38.039.51.187.52.15.011.307-.251.445-.483.177-.298.377-.632.686-.632.027 0 .054.002.082.007.42.077.346.639.28 1.134-.04.302-.085.643-.008.78.1.175.282.203.57.235.201.022.408.045.592.152.184.108.289.281.39.449.14.23.271.448.61.516.631.128 1.871-.298 2.191-.864.16-.282.144-.607.128-.951-.016-.346-.033-.703.132-1.034.15-.302.356-.511.554-.713.214-.217.415-.422.511-.721.185-.575.126-2.095-.158-2.509ZM13.983 14.461c-.107-.056-.198-.008-.362.09-.142.085-.303.182-.51.175-.2-.006-.368-.132-.515-.244-.215-.162-.323-.224-.45-.142-.039.025-.064.067-.076.128-.058.285.167.802.31 1.011.16.238.433.521.814.521.348 0 .664-.367.792-.614.123-.237.284-.775-.003-.925Z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>'
    },

    openClose(newSection) {
      // only for < medium breakpoint
      if (isMobile()) {
        this.section = newSection
      }
    },

    switchType(event) {
      let value = $(event.target).val()

      this.types = value === "" ? [] : [value]

      this.run()
    },

    resetFilters() {
      this.types = []
      this.categories = []
      this.locations = []
      this.years = []

      // reset querystring
      var urlWithParameters =
        window.location.pathname + "?" + new URLSearchParams().toString()
      history.pushState(null, "", urlWithParameters)

      this.run()
    },

    clearTypes: function () {
      this.types = []
    },

    selectType(type) {
      this.types = [type]
    },

    clearCategory(category) {
      let index = this.categories.indexOf(category)

      if (index > -1) {
        this.categories.splice(index, 1)
        this.run()
      }
    },

    clearLocation(location) {
      let index = this.locations.indexOf(location)

      if (index > -1) {
        this.locations.splice(index, 1)
        this.run()
      }
    },

    clearYear(year) {
      let index = this.years.indexOf(year)

      if (index > -1) {
        this.years.splice(index, 1)
        this.run()
      }
    },

    toggleFilters() {
      this.showFilters = !this.showFilters

      this.openClose("categories")

      // this is a horrible calculation to make sure the faded
      // background only covers from the top of the filter
      // window to the end of the document

      let background = $(".js-filter-background")
      let bounds = background.parent().get(0).getBoundingClientRect()

      let offsetOfFilterWindow = 66
      let newHeight =
        document.body.scrollHeight -
        bounds.top -
        window.scrollY -
        offsetOfFilterWindow
      background.height(newHeight)

      let classes = "bg-black bg-opacity-40 opacity-100 pl-16"
      if (this.showFilters) {
        window.setTimeout(() => {
          background.removeClass("opacity-0 pl-[100%]")
          background.addClass(classes)
        }, 100)
      } else {
        background.addClass("opacity-0 pl-[100%]")
        background.removeClass(classes)
      }
    },

    run: function () {
      this.loading = true

      const params = new URLSearchParams()

      this.types.forEach((type) => {
        params.append("types", type)
      })

      this.categories.forEach((category) => {
        params.append("categories", category)
      })

      this.locations.forEach((location) => {
        params.append("locations", location)
      })

      this.years.forEach((year) => {
        params.append("years", year)
      })

      var urlWithParameters = window.location.pathname + "?" + params.toString()
      history.pushState(null, "", urlWithParameters)

      let resultsPanel = document.getElementsByClassName("js-resource-results")

      this.showFilters = false

      params.append("_csrf", token)

      let render = (html) => {
        if (resultsPanel.length === 1) {
          this.loading = false
          resultsPanel[0].innerHTML = html

          // resultsPanel[0].dispatchEvent(
          //   new CustomEvent("filters-closed", { bubbles: true })
          // )
        }
      }

      fetch("/resources", {
        method: "POST",
        body: params
      })
        .then((r) => r.text())
        .then((h) => render(h))
        .catch((e) => console.warn(e))
    }
  }
}

window._carousel = function (slideLength) {
  let next = function () {
    let newPosition = this.slide + 1

    if (this.slide == this.length - 1) {
      return
    }

    this.slide = newPosition
    this.scroll()
  }

  let previous = function () {
    let newPosition = this.slide - 1

    if (this.slide == 0) {
      return
    }

    this.slide = newPosition
    this.scroll()
  }

  return {
    slide: 1, // start on 1 so there's a slide hidden to the left
    length: slideLength,

    next: next,
    previous: previous,

    resize() {
      this.slide = 1
      this.scroll()
    },

    scroll() {
      let container = this.$refs.container
      let totalWidth = $(container).width()
      let slideWidth = $(container).width()

      let newLeft = this.slide * slideWidth - (totalWidth - slideWidth) / 2

      this.$refs.container.scrollTo({ left: newLeft, behavior: "smooth" })
    }
  }
}

window._contentSlider = function (slideLength) {
  let isMobile = () => window.innerWidth < 768
  let isDesktop = () => window.innerWidth >= 1024

  let next = function () {
    let newPosition = this.slide + 1

    if (this.slide == this.length - this.slidesPerScreen) {
      return
    }

    this.slide = newPosition

    this.scroll()
  }

  let previous = function () {
    let newPosition = this.slide - 1

    if (this.slide == 0) {
      return
    }

    this.slide = newPosition

    this.scroll()
  }

  return {
    slide: 0,
    length: parseInt(slideLength),
    slidesPerScreen: isDesktop() ? 3 : 1,
    next: next,
    previous: previous,
    progress: 0,
    showNext: true,
    showPrevious: false,

    resize() {
      this.slide = 0
      this.slidesPerScreen = isDesktop() ? 3 : 1
      this.showNext = true
      this.showPrevious = false
      this.scroll()
    },

    scroll() {
      let container = this.$refs.container
      let slideWidth = isMobile()
        ? $(container).width()
        : $(container).width() / (this.slidesPerScreen + 0.5)

      let newLeft = this.slide * slideWidth

      this.progress = (this.slide + this.slidesPerScreen) / this.length

      this.showPrevious = this.slide > 0
      this.showNext = this.slide < this.length - this.slidesPerScreen

      $(this.$refs.progress).css("width", `${this.progress * 100}%`)
      this.$refs.container.scrollTo({ left: newLeft, behavior: "smooth" })
    }
  }
}

window._mobileCollapse = function () {
  let isMobile = () => window.innerWidth < 475

  return {
    showHandles: isMobile(),
    open: false,

    resize() {
      this.showHandles = isMobile()
    },

    toggle() {
      if (isMobile()) {
        this.open = !this.open
      }
    }
  }
}

window._showcase = function (groupCount) {
  return {
    expand: groupCount > 1,
    open: false,

    showAll() {
      this.open = !this.open
    }
  }
}

window._tools = function () {
  return {
    dumpOpen: false,

    toggle() {
      this.dumpOpen = !this.dumpOpen

      if (this.dumpOpen) $(".js-slice-info").removeClass("hidden")
      else $(".js-slice-info").addClass("hidden")
    }
  }
}

window._testimonialSlider = function (slideLength) {
  let isMobile = () => window.innerWidth < 768
  let isDesktop = () => window.innerWidth >= 1024

  let next = function () {
    let newPosition = this.slide + 1

    if (this.slide == this.length - this.slidesPerScreen) {
      return
    }

    this.slide = newPosition

    this.scroll()
  }

  let previous = function () {
    let newPosition = this.slide - 1

    if (this.slide == 0) {
      return
    }

    this.slide = newPosition

    this.scroll()
  }

  return {
    slide: 0,
    length: parseInt(slideLength),
    slidesPerScreen: isDesktop() ? 2 : 1,
    next: next,
    previous: previous,
    progress: 0,
    showNext: true,
    showPrevious: false,

    resize() {
      this.slide = 0
      this.slidesPerScreen = isDesktop() ? 2 : 1
      this.showNext = true
      this.showPrevious = false
      this.scroll()
    },

    scroll() {
      let container = this.$refs.container
      let slideWidth = isMobile()
        ? $(container).width()
        : $(container).width() / (this.slidesPerScreen + 0.5)

      let newLeft = this.slide * slideWidth

      this.progress = (this.slide + this.slidesPerScreen) / this.length

      this.showPrevious = this.slide > 0
      this.showNext = this.slide < this.length - this.slidesPerScreen

      $(this.$refs.progress).css("width", `${this.progress * 100}%`)
      this.$refs.container.scrollTo({ left: newLeft, behavior: "smooth" })
    }
  }
}

window._steps = function (steps, completionUrl) {
  let stepNumberFromHash = () =>
    window.location.hash && window.location.hash.startsWith("#step-")
      ? parseInt(window.location.hash.substring(6))
      : 0

  return {
    step: stepNumberFromHash(),

    hashChange() {
      this.step = stepNumberFromHash()
    },

    select(step) {
      if (step < this.step) {
        this.step = step
        window.location.hash = `step-${this.step}`
      }
    },

    next() {
      if (this.step == steps - 1) window.location.href = completionUrl

      if (this.step < steps - 1) {
        this.step++
        window.location.hash = `step-${this.step}`
      }
    },

    prev() {
      if (this.step > 0) {
        this.step--
        window.location.hash = `step-${this.step}`
      }
    }
  }
}

window._secondaryNavigationScroller = function () {
  return {
    scrollPosition: 0,

    update() {
      this.scrollPosition = Math.round(
        (window.scrollY / (document.body.offsetHeight - window.innerHeight)) *
          100
      )
    }
  }
}

window._questions = function (questionsCount, watermark) {
  let resizer = () => {
    let maxHeight = 0

    $(".question").each(function () {
      let h = $(this).height()
      maxHeight = h > maxHeight ? h : maxHeight
    })

    let questionHeight = maxHeight
    let scrollOffset = window.visualViewport.height / 2 - questionHeight / 2

    $(".question").css("scroll-margin-bottom", `${questionHeight / 2}px`)
    $(".js-section").css("padding-bottom", `${scrollOffset}px`)
  }

  resizer()

  return {
    question: watermark,
    watermark: watermark,
    questionsCount: questionsCount,

    resize() {
      resizer()
    },

    isActive(q) {
      return q <= this.watermark
    },

    isCurrentQuestion(q) {
      return q == this.question
    },

    isWatermark(q) {
      return q == this.watermark
    },

    activate(q) {
      if (q >= this.watermark) {
        this.watermark = q + 1
      }

      if (!this.isActive(q) || q == questionsCount - 1) {
        return
      }

      $(".readiness-questions .message").addClass("hidden")

      this.question = q + 1

      document.getElementById(`question-${this.question}`).scrollIntoView({
        behavior: "smooth",
        block: "center"
      })
    },

    saveProgress() {
      fetch("/reports/save-progress", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams(
          new FormData($("form.readiness-report-form").get(0))
        ).toString()
      }).then(() => console.log("saved"))
    }
  }
}
